import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { maxLengthValidator, minLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';
import { NoteCardElement } from './note-card-element';

export class NoteCardFormGroup extends FormGroup<{
    notes: FormArray<NoteCardElementFormGroup>;
}> {
    constructor() {
        super({
            notes: new FormArray<NoteCardElementFormGroup>([]),
        });
    }

    setValueFromModel(model: NoteCardElement[]): void {
        this.controls.notes.clear();
        model.forEach((element) => {
            const control = new NoteCardElementFormGroup();
            control.setValueFromModel(element);
            this.controls.notes.push(control);
        });
    }

    getModelFromValue(): NoteCardElement[] {
        return this.controls.notes.controls
            .filter((control) => {
                return control.controls.note.value !== '';
            })
            .map((control) => {
                return control.getModelFromValue();
            });
    }
}

export class NoteCardElementFormGroup extends FormGroup<{ note: FormControl<string | null> }> {
    constructor() {
        super({
            note: new FormControl<string | null>('', [
                Validators.required,
                notWhitespaceValidator(),
                minLengthValidator(1),
                maxLengthValidator(1000),
            ]),
        });
    }

    public valueModel: NoteCardElement;

    setValueFromModel(model: NoteCardElement): void {
        this.valueModel = model;

        this.setValue({
            note: model.note,
        });
    }

    getModelFromValue(): NoteCardElement {
        this.valueModel.note = this.controls.note.value;

        return {
            ...this.valueModel,
            modifiedInitials: this.valueModel.modifiedInitials || null,
            modifiedTime: this.valueModel.modifiedTime || null,
        };
    }
}
